import { NavLink } from 'react-router'

/*
 * The footer for /studio only: the Studio description, the links that matter
 * to a self-serve visitor, the company and policy pages, and the social links
 * the shared footer carries.
 */
const GROUPS: { title: string; links: { label: string; href: string; external?: boolean }[] }[] = [
  {
    title: 'Studio plan',
    links: [
      { label: 'How it works', href: '#example' },
      { label: 'Pricing', href: '#pricing' },
      { label: 'Compare plans', href: '/pricing' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Support', href: '/support' },
      { label: 'Trust Center', href: 'https://app.vanta.com/singulate/trust/s77awike6j7no037hyfxa', external: true },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: '/about' },
      { label: 'Blog', href: '/blog' },
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
    ],
  },
]

const SOCIAL = [
  { label: 'YouTube', href: 'https://www.youtube.com/@singulate-ai' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/singulate-ai' },
  { label: 'X', href: 'https://x.com/singulate_ai' },
]

function FooterLink({ label, href, external }: { label: string; href: string; external?: boolean }) {
  const cls = 'text-small text-dark-blue-50 no-underline hover:text-white'
  if (external || href.startsWith('#')) {
    return (
      <a href={href} className={cls} {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}>
        {label}
      </a>
    )
  }
  return (
    <NavLink to={href} className={cls}>
      {label}
    </NavLink>
  )
}

export function StudioFooter() {
  return (
    <footer className="bg-dark-blue-900">
      <div className="mx-auto flex w-full max-w-main flex-col gap-10 px-6 py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))]">
          <div className="flex flex-col gap-4">
            <img src="/media/singulate-logo-white.svg" alt="Singulate" width={128} height={29} className="h-7 w-auto" />
            <p className="m-0 max-w-xsmall text-small text-dark-blue-50">
              Personal emails for the people your business wants to reach.
            </p>
          </div>
          {GROUPS.map((g) => (
            <div key={g.title} className="flex flex-col gap-3">
              <p className="m-0 text-small font-medium text-white">{g.title}</p>
              {g.links.map((l) => (
                <FooterLink key={l.href + l.label} {...l} />
              ))}
            </div>
          ))}
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4 border-0 border-t border-solid border-white/10 pt-6">
          <p className="m-0 text-small text-dark-blue-50">&copy; {new Date().getFullYear()} Singulate</p>
          <div className="flex gap-6">
            {SOCIAL.map((s) => (
              <a key={s.href} href={s.href} target="_blank" rel="noreferrer" className="text-small text-dark-blue-50 no-underline hover:text-white">
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
